/**
 * 使用方法：
 * -- 在需要使用的地方引入文件：<script src="{{ 'component-countdown.js' | asset_url }}" defer></script>
 * -- 在需要使用的地方添加标签：<component-countdown></component-countdown>
 * -- 传入截止时间参数：2024/03/03 23:59:59 PST
 * -- <component-countdown data-date="2024/03/03 23:59:59 PST"></component-countdown>
 * -- 描述文字：
 * -- <component-countdown data-date="2024/03/03 23:59:59 PST" data-des="End in"></component-countdown>
 * -- 天 时 分 秒的文字 以英文空格隔开(默认为：Days Hours Mins Secs)
 * -- <component-countdown data-date="2024/03/03 23:59:59 PST" data-tag-texts="Days Hours Mins Secs"></component-countdown>
 */

if (customElements.get("component-countdown") === undefined) {
  customElements.define(
    "component-countdown",
    class Countdown extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // 解析截止时间
        if (this.dataset.date !== undefined) {
          this.deadLine = this.parseDate(this.dataset.date); // ✅ 使用兼容函数
        }

        // 获取描述文字
        if (this.dataset.des !== undefined) {
          this.des = this.dataset.des;
        }

        // 获取标签描述信息
        this.dataset.tagTexts !== undefined
          ? (this.tagTexts = this.dataset.tagTexts.split(" "))
          : (this.tagTexts = ["Days", "Hours", "Mins", "Secs"]);

        this.initInnerHTML();
        this.interval = setInterval(() => {
          this.computedTime();
          this.updateTime();
        }, 1000);
      }

      // ✅ iOS 时间格式兼容函数
      parseDate(dateStr) {
        let date = new Date(dateStr);
        if (!isNaN(date.getTime())) return date;

        const match = dateStr.match(
          /^(\d{4})[\/\-](\d{1,2})[\/\-](\d{1,2})\s+(\d{2}):(\d{2}):(\d{2})\s+(PST|PDT|UTC|GMT|[+-]\d{2}:?\d{2}|\d{4})$/
        );
        if (match) {
          let [_, y, m, d, h, min, s, tz] = match;

          m = m.padStart(2, "0");
          d = d.padStart(2, "0");

          // 转换常见时区
          if (tz === "PST") tz = "-08:00";
          else if (tz === "PDT") tz = "-07:00";
          else if (tz === "UTC" || tz === "GMT") tz = "+00:00";
          else if (/^\d{4}$/.test(tz)) tz = tz.slice(0, 2) + ":" + tz.slice(2); // 如0800 => 08:00
          else if (/^[+-]\d{4}$/.test(tz)) tz = tz.slice(0, 3) + ":" + tz.slice(3); // 如+0800 => +08:00

          const isoStr = `${y}-${m}-${d}T${h}:${min}:${s}${tz}`;
          const parsed = new Date(isoStr);
          return isNaN(parsed.getTime()) ? new Date() : parsed;
        }

        return new Date(); // 解析失败 fallback
      }

      computedTime() {
        let timeDifference = this.deadLine.getTime() - new Date().getTime();
        if (timeDifference > 0) {
          this.days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
          this.hours = Math.floor(
            (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          this.mins = Math.floor(
            (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
          );
          this.secs = Math.floor((timeDifference % (1000 * 60)) / 1000);
        } else {
          this.days = 0;
          this.hours = 0;
          this.mins = 0;
          this.secs = 0;
          clearInterval(this.interval);
        }
      }

      formatDate(num) {
        return num.toString().padStart(2, "0");
      }

      updateTime() {
        this.querySelector(".day .countdown-number").innerHTML =
          this.formatDate(this.days);
        this.querySelector(".hour .countdown-number").innerHTML =
          this.formatDate(this.hours);
        this.querySelector(".minute .countdown-number").innerHTML =
          this.formatDate(this.mins);
        this.querySelector(".second .countdown-number").innerHTML =
          this.formatDate(this.secs);
      }

      initInnerHTML() {
        this.innerHTML = `
          <div class="des">${this.des || ""}</div>
          <div class="countdown-wrapper">
              <div class="countdown-item day">
                  <div class="countdown-number">00</div>
                  <div class="countdown-text">${this.tagTexts[0]}</div>
              </div>
              <div class="countdown-item hour">
                  <div class="countdown-number">00</div>
                  <div class="countdown-text">${this.tagTexts[1]}</div>
              </div>
              <div class="countdown-item minute">
                  <div class="countdown-number">00</div>
                  <div class="countdown-text">${this.tagTexts[2]}</div>
              </div>
              <div class="countdown-item second">
                  <div class="countdown-number">00</div>
                  <div class="countdown-text">${this.tagTexts[3]}</div>
              </div>
          </div>
        `;
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }
    }
  );
}
